import React, { useEffect, useState } from 'react'

import styles from './LoadingSpinner.module.scss'

type Props = {
  loading: boolean
  /**
   * If true, disables the built-in 60s safety-net timer that auto-hides the spinner.
   * Opt in only when the parent guarantees it will manage the spinner lifecycle —
   * e.g. flows that can legitimately exceed 60s (reinstatement workflow polling).
   * Defaults to false to preserve the existing safety net for all other callers.
   */
  disableAutoHide?: boolean
  /** Optional heading shown below the spinner (e.g. "We're processing your request"). */
  heading?: string
  /** Optional subtext shown below the heading (e.g. "Please do not refresh or leave this page."). */
  subtext?: string
}

const LoadingSpinner: React.FC<Props> = ({ loading, disableAutoHide = false, heading, subtext }) => {
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(loading)
    if (disableAutoHide) return
    // set 1 minute timer to stop loading spinner on error
    const timer = setTimeout(() => {
      setLoading(false)
    }, 60000)
    return () => clearTimeout(timer)
  }, [loading, disableAutoHide])

  return isLoading ? (
    <div className={styles['spinner-overlay']}>
      <div className={styles['loading-spinner']}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {(heading || subtext) && (
        <div className={styles['loading-message']}>
          {heading && <p className={styles['loading-heading']}>{heading}</p>}
          {subtext && <p className={styles['loading-subtext']}>{subtext}</p>}
        </div>
      )}
    </div>
  ) : null
}

export default LoadingSpinner
